window.addEventListener('frame-ready', init)

function init() {

    const page = document.querySelector('.Search')

    if(!page) return

    const filters = Array.from(document.querySelectorAll('[data-filter]'))
    const products = Array.from(document.querySelectorAll('.search-column'))

    if(!filters) return

    filters.forEach(filter => {
        filter.addEventListener('click', () => triggerFilter(filter))
    })

    function triggerFilter(filter) {
        filters.forEach(filter => filter.classList.remove('current'))
        filter.classList.add('current')
        filterProducts(products, filter.dataset.filter)
    }

    function filterProducts(products, filter) {

        products.forEach(product => {
            if(filter === 'all') {
                product.classList.remove('hidden')
            } else {
                if(product.classList.contains(filter)) {
                    product.classList.remove('hidden')
                } else {
                    if(!product.classList.contains('hidden')) {
                        product.classList.add('hidden')
                    }
                }
            }
        })
    }
}
